/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResolvedReference = {
  repositoryId: number;
  owner: string;
  repository: string;
  ref: string;
  sha: string;
  defaultBranch: string;
};

/** @internal */
export const ResolvedReference$inboundSchema: z.ZodType<
  ResolvedReference,
  z.ZodTypeDef,
  unknown
> = z.object({
  repository_id: z.number().int(),
  owner: z.string(),
  repository: z.string(),
  ref: z.string(),
  sha: z.string(),
  default_branch: z.string(),
}).transform((v) => {
  return remap$(v, {
    "repository_id": "repositoryId",
    "default_branch": "defaultBranch",
  });
});
/** @internal */
export type ResolvedReference$Outbound = {
  repository_id: number;
  owner: string;
  repository: string;
  ref: string;
  sha: string;
  default_branch: string;
};

/** @internal */
export const ResolvedReference$outboundSchema: z.ZodType<
  ResolvedReference$Outbound,
  z.ZodTypeDef,
  ResolvedReference
> = z.object({
  repositoryId: z.number().int(),
  owner: z.string(),
  repository: z.string(),
  ref: z.string(),
  sha: z.string(),
  defaultBranch: z.string(),
}).transform((v) => {
  return remap$(v, {
    repositoryId: "repository_id",
    defaultBranch: "default_branch",
  });
});

export function resolvedReferenceToJSON(
  resolvedReference: ResolvedReference,
): string {
  return JSON.stringify(
    ResolvedReference$outboundSchema.parse(resolvedReference),
  );
}
export function resolvedReferenceFromJSON(
  jsonString: string,
): SafeParseResult<ResolvedReference, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResolvedReference$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResolvedReference' from JSON`,
  );
}
